module.exports = __webpack_public_path__ + "img/ai_qrcode.081f91be.jpg";